import React from "react";
import { ReschedulingProvider } from "./ReschedulingProvider";
import FlowManager from "./FlowManager";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../actions";
import { useGetFeatureFlag } from "hooks/useGetFeatureFlag";
import * as selectors from "selectors";
import { LoadingScreen } from "components/EventScheduling/EventSchedulingUtils";

export default function Rescheduling() {
  const dispatch = useDispatch();
  const userId = useSelector(selectors.getUserId);
  const { data: rescheduling12hrWindowPilot, isLoading } = useGetFeatureFlag(
    userId as string,
    "12hr_window_rescheduling_pilot"
  );

  React.useEffect(() => {
    dispatch(actions.checkAuthState());
  }, []);

  if (isLoading || !userId) return <LoadingScreen />;

  return (
    <ReschedulingProvider rescheduling12hrWindowPilot={rescheduling12hrWindowPilot}>
      <FlowManager />
    </ReschedulingProvider>
  );
}
